// extracted by mini-css-extract-plugin
export var buttons = "_8w-0";
export var buttonsActive = "_8w-h";
export var cancelConfirm = "_8w-1";
export var closeButton = "_8w-2";
export var column = "_8w-3";
export var container = "_8w-4";
export var detailHeader = "_8w-6";
export var detailTitle = "_8w-7";
export var detailsContent = "_8w-5";
export var header = "_8w-8";
export var headerWithClose = "_8w-9";
export var icon = "_8w-a";
export var infoIcon = "_8w-c";
export var informationContainer = "_8w-b";
export var sideDrawer = "_8w-d";
export var sideDrawerOpen = "_8w-e";
export var stickyFooter = "_8w-f";
export var typeOption = "_8w-g";